import { BaseEntity } from "yt-ng-framework";

export class FakDokumentUplata extends BaseEntity{

    constructor(){
        super();
    }

    FakDokumentID:number=null;
    PodVrstaDokumentaStavkaID: number=null;
    Broj:number=null;
    RB:number=null;
    Datum: Date = null;
    Iznos: number=null;

    Deserialize(input: any) {
        this.ID=input.ID;
        this.FakDokumentID=input.FakDokumentID;
        this.PodVrstaDokumentaStavkaID=input.PodVrstaDokumentaStavkaID;
        this.Broj=input.Broj;
        this.RB=input.RB;
        this.Datum=input.Datum;
        this.Iznos=input.Iznos;
        return this
    }

    Serialize(input:FakDokumentUplata){
        return input;
    }


}